<template>
  <div class="scroll-nav">
    <button
      class="scroll-nav__btn scroll-nav__btn--prev"
      @click="$emit('prev')">
      ▲
    </button>
    <button
      class="scroll-nav__btn scroll-nav__btn--next"
      @click="$emit('next')">
      ▼
    </button>
  </div>
</template>

<script>
export default {
  name: 'ScrollNav',
}
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/member';

.scroll-nav {
  position: fixed;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  background-color: $white;
  border-radius: 20px;
  box-shadow: 1px 1px 6px 0 $grey05;
  overflow: hidden;
  z-index: 100;
  @media screen and (min-width: 992px) {
    // PC: 通知一覧コンテンツ(max-width: 800px)の右端に沿って配置
    // 920px = サイドバー幅(120px) + コンテンツ幅(800px)
    // 32px = ScrollNav幅(24px) + ギャップ(8px)
    right: calc((100vw - 920px) / 2 - 32px);
  }

  &__btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 24px;
    height: 52px;
    border: none;
    background-color: transparent;
    color: $l-blue;
    font-size: $fs-s;
    cursor: pointer;
    padding: 8px 0;

    &--prev {
      justify-content: flex-start;
    }
    &--next {
      justify-content: flex-end;
    }
  }
}
</style>
